import React, { memo } from "react";
import SendIcon from "./SendIcon";
import { InputContainer, ChatInput as StyledInput, SendButton } from "./styles";

const ChatInput = memo(
	({ value, onChange, onSend, onKeyPress, disabled, inputRef }) => {
		return (
			<InputContainer>
				<StyledInput
					ref={inputRef}
					type="text"
					placeholder="Escreva sua mensagem aqui..."
					value={value}
					onChange={onChange}
					onKeyPress={onKeyPress}
				/>
				<SendButton
					onClick={onSend}
					disabled={!value.trim() || disabled}
					aria-label="Enviar mensagem"
				>
					<SendIcon />
				</SendButton>
			</InputContainer>
		);
	}
);

ChatInput.displayName = "ChatInput";

export default ChatInput;
